module.exports = __webpack_public_path__ + "static/media/sdg11.cfd3e680.png";